<template lang="pug">
//-デバッグ
Debug

.l-home

  //-イントロ
  Intro

  //-チュートリアル
  Tutorial

  //-MAP
  Map

  //-季節切り替えボタン
  //- Season

  //-マンダラ
  Mandara

  //-ロゴ
  Logo

  //-ハンバーガー
  Hamburger
  
  //-グロナビ
  Nav

  //-SP時のみPINクリック時の簡易情報
  ArticleEasyInfo

  //-NotFound記事がなかった時用
  NotFound(v-if="store.ui.state.article.notfound")

  //-記事詳細
  transition(name="article")
    router-view

</template>



<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'
.l-home
  posf()
  wh()


/** transition */
.article-enter-active,
.article-leave-active
  +pc()
    transition transform 750ms $easeOutExpo
  +sp()
    // transition bottom 750ms $easeOutExpo
    transition transform 750ms $easeOutExpo

.article-enter-from,
.article-leave-to
  +pc()
    transform translateX(550px) !important

.article-enter-from
  +sp()
    transform translateY(calc(100% - 305px))
.article-leave-to
  +sp()
    transform translateY(100%)

.article-enter-to,
.article-leave-from
  +pc()
    transform translateX(0px) !important
  +sp()
    transform translateY(0px)

</style>


<script>
import { defineComponent, computed, ref, inject ,onMounted, reactive ,onUpdated,watch} from "vue";
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import Map from '@/components/map/Map.vue'
import ArticleEasyInfo from '@/components/article/ArticleEasyInfo'
import Season from '@/components/season/Season.vue'
import Mandara from '@/components/mandara/Mandara.vue'
import Logo from '@/components/logo/Logo.vue'
import Hamburger from '@/components/nav/Hamburger.vue'
import Nav from '@/components/nav/Nav.vue'
import Intro from '@/components/intro/Intro.vue'
import Debug from '@/components/debug/Debug.vue'
import Tutorial from '@/components/tutorial/Tutorial.vue'
import NotFound from '@/views/NotFound.vue'

export default defineComponent({
  components:{
    Map,
    ArticleEasyInfo,
    Season,
    Mandara,
    Logo,
    Hamburger,
    Nav,
    Intro,
    Debug,
    Tutorial,
    NotFound
  },

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    //初回アクセスしたルーター名を記録
    store.ui.state.firstRouteName = router.currentRoute.value.name
    
    //マップが変わった時の仏モードの制御
    watch(
      ()=> [store.ui.state.maptype],
      (value) => {
        const maptype = value[0]
        if(maptype == 1
          || maptype == 2
          || maptype == 4
        ){
          store.ui.state.hotoke = false
        }
      }
    )

    onUpdated(()=>{
      if(window.history.state.current == '/' && window.history.state.forward){
        const paths = window.history.state.forward.match(/map(.*)/)
        if(paths[1]){
          store.ui.state.maptype = 1
        }
      }
    })
    
    return{
      store
    }
  }
})
</script>
